import React from "react";
import TableViewer from "../TableViewer";
import { v4 as uuidv4 } from 'uuid';
import { nanoid } from "nanoid";
import { addTopic, removeTopic } from "../../utils/socket.services";
import { getOneThing, getPermissionObject } from "../../utils/useful";
import HttpServices from "../../utils/Http.services";
import ItemModal from "../../modals/ItemModal";
import RemoveModal from "../../modals/RemoveModal";
import { adminPages } from "../../variables/adminPages";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import moment from "moment";

class TableWidget extends React.Component {

    state = {
        data: [],
        topicId: nanoid(10),
        limit: 30,
        extraItems:[]
        // showTable:false
    }




    componentDidMount() {
        this.init()
        window.addEventListener('reloadFetchData', this.handleReloadFetchData)
    }

    handleReloadFetchData = () => {
        this.fetchData(true)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data?.thing != this.props.widget?.thing) {
            this.init()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('reloadFetchData', this.handleReloadFetchData)
        removeTopic(this.state.topicId, this.props.widget.page, 'admin')
    }

    init() {

        this.setState({ data: [] }, () => {
            // getOneThing({ id: this.props.widget.thing }, (fetchResult, fetchError, status) => {
            //     // console.log(fetchResult)
            //     if (fetchResult) {
            //         this.setState({ thing: fetchResult.info }, () => {


            // let headers = [...this.props.widget.headers]
            // if (Array.isArray(this.props.widget.characteristic)) {
            //     this.props.widget.characteristic.forEach(element => {

            //         headers.push({ key: "data." + element, type: 'TextInput', information: { label: this.getLabel(element) } })

            //     });
            // this.setState({ headers })
            // }

            this.fetchData()
            // })
            //     }
            // })
        })
    }



    openEditModal = (prop, index) => {
        // console.log(prop)
        this.itemModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }


    openRefModal = (prop, index, reference) => {
        // console.log("openRefModal")
        // console.log(reference)
        let page = adminPages[reference.ref]

        let _id = typeof prop == 'object' ? prop._id : prop

        let body = { filter: { _id } }

        if (page.page) {
            body.filter = { ...{ page: page.key, _id }, ...body.filter }
        }
        console.log(body)
        HttpServices.request(page.fetchOne, body, (fetchResult, fetchError) => {

            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            let newItem = { page, data: fetchResult.info }
            let extraItems = this.state.extraItems
            extraItems.push(newItem)
            this.setState({ extraItems }, () => {
                setTimeout(() => {
                    this['itemModal' + String(extraItems.length - 1)].modal.showModal()
                }, 10);
            })

        })

    }



    itemAdded = (newItem, modalIndex) => {
        // console.log(newItem)

        if (newItem && modalIndex == null) {
            let data = this.state.data
            data.splice(0, 0, newItem)
            // console.log(newItem)
            // console.log(data)
            this.setState(data)
        } else {
            this.fetchData(true)
        }
    }

    itemEdited = (editedItem, id, modalIndex) => {
        // console.log(editedItem)
        if (modalIndex == null) {
            let data = this.state.data
            this.state.data.forEach((element, index) => {
                let id = element.id ?? element._id
                let currentId = this.state.currentItem.id ?? this.state.currentItem._id
                if (id === currentId) {
                    // console.log(id)
                    data[index] = Object.assign({}, editedItem)
                }
            })
            this.setState({ data }, () => {
                // console.log(editedItem)
                // console.log(data)
                // this.TableViewer.forceUpdateData()
            })
        } else {
            this.fetchData()
        }
    }


    fetchData = (getCount) => {
        this.setState({ isLoadingData: true });
        let body = this.props.widget.filter ?? {}; let page = this.props.widget
        body.page = page.page; body.limit = this.state.limit; body.skip = this.state.currentPage; body.filter = this.state.filter ?? {}

        if (this.state.filter2) body.filter2 = this.state.filter2

        if (this.props.widget.postBody) body.filter = { ...body.filter, ...this.props.widget.postBody }

        // Add applet filter if provided via variables (for branch-specific widgets)
        if (this.props.variables?.applet) {
            body.filter.applet = this.props.variables.applet
        }

        // Add time filter if specified
        if (this.props.widget.timeFilter) {
            const now = moment()
            let startDate
            
            switch (this.props.widget.timeFilter) {
                case 'week':
                    startDate = now.clone().subtract(1, 'week').startOf('day').valueOf()
                    break
                case 'month':
                    startDate = now.clone().subtract(1, 'month').startOf('day').valueOf()
                    break
                case '3months':
                    startDate = now.clone().subtract(3, 'months').startOf('day').valueOf()
                    break
                case '6months':
                    startDate = now.clone().subtract(6, 'months').startOf('day').valueOf()
                    break
                default:
                    startDate = null
            }
            
            if (startDate) {
                body.filter['uDate'] = { $gte: startDate }
            }
        }

        // TODO: Backend permissions - Currently commented out for backend permission implementation
        // Add user filter if user has "self" permission
        // const permissionRoot = this.props.variables?.permissionRoot
        // if (permissionRoot && this.props.user?.info) {
        //     const userPermissions = this.props.user.info.permissions || []
        //     let hasSelfPermission = false
        //     
        //     // Check if user has "self" permission
        //     for (let i = 0; i < userPermissions.length; i++) {
        //         const userPermission = userPermissions[i].permissions
        //         const permResult = getPermissionObject(userPermission, permissionRoot + '.self')
        //         if (permResult?.allowed) {
        //             hasSelfPermission = true
        //             break
        //         }
        //     }
        //     
        //     // If user has "self" permission, filter by their user ID
        //     if (hasSelfPermission && this.props.user.info._id) {
        //         body.filter.user = this.props.user.info._id
        //     }
        // }
        
        // For now, backend will handle permission-based filtering
        // User filter will be added by backend based on permissions

        if (this.props.widget.populate) body.populate = this.props.widget.populate

        if (this.props.widget.sort) body.sort = this.props.widget.sort

        if (this.state.totalCount == null || getCount) body.getCount = true


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        // console.log(body)
if(this.props.widget.self){
    // if(!body.filter.values){
    //     body.filter.values={} 
    // }
    body.filter[`values.${this.props.widget.self}`] = this.props.user.info._id
}
        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            addTopic(this.state.topicId, page.page, 'admin', null, this.updateData)

            this.setState({ data: [], showTable: false }, () => {
                setTimeout(() => {
                    this.setState({ data: fetchResult.info, showTable: true })
                }, 100);
            })

            if (fetchResult.count != null) {
                this.setState({ totalCount: fetchResult.count })
            }
        })
    }






    getLabel(dataObject) {
        // console.log(dataObject)
        if (this.state.thing?.structure) {
            // let result = ''
            for (let i = 0; i < this.state.thing.structure.length; i++) {
                const structure = this.state.thing.structure[i];
                if (structure.dataObject == dataObject) {
                    return structure.label
                }
            }

        }
    }


    updateData = (newData) => {
        // let data = this.state.data
        console.log(newData)
        // data.splice(0, 0, { cDate: new Date(), data: newData })
        // data = { ...data, ...newData }
        // this.setState({ data })
        // console.log("updateData")
    }


    functionsHandler = (prop, index, reference) => {

        if (this[reference.function]) {
            this[reference.function](prop, index, reference)
        }

    }

    openStatusModal = (rowData, index, action) => {
        // Store the row data that should show the status modal
        this.setState({ statusModalRowId: rowData._id || rowData.id }, () => {
            // Trigger a custom event or use a ref to open the modal
            // Since we can't directly access the table component, we'll use a different approach
            // The table component will check for this state via a prop or we'll use a global event
            window.dispatchEvent(new CustomEvent('openStatusModal', { detail: { rowId: rowData._id || rowData.id } }))
        })
    }
    render() {
        return (
            <div className="w-100" style={{ position: 'relative', height: '100%', maxHeight: '100%', overflow: 'hidden', display: 'flex', flexDirection: 'column' }} >
                {this.state.showTable && (
                    <div className="flex-1 no-scrollbar" style={{ position: 'relative', width: '100%', overflow: 'auto', minHeight: 0 }}>
                        <TableViewer
                            isLoading={this.state.isLoadingData}
                            headers={this.props.widget?.headers}
                            data={this.state.data}
                            variables={this.props.variables}
                            top={0}
                            actions={this.props.widget?.actions}
                            // openEditModal={this.openEditModal}
                            openEditModal={this.openEditModal}
                            openStatusModal={this.openStatusModal}
                            sendFinancialEmail={this.sendFinancialEmail}
                            openRemoveModal={this.openRemoveModal}
                            // updateData={this.updateData}
                            functionsHandler={this.functionsHandler}
                        />
                    </div>
                )}


                <ItemModal
                    ref={el => this.itemModal = el}
                    page={this.props.widget}
                    headers={this.props.widget?.headers}
                    initData={this.state.currentItem}
                    variables={this.props.variables}
                    itemAdded={this.itemAdded}
                    itemEdited={this.itemEdited}
                    openRefModal={this.openRefModal}
                    functionsHandler={this.functionsHandler}
                    showDates={true}
                />


                {this.state.extraItems && this.state.extraItems.map((prop, index) => {
                    return (

                        <ItemModal
                            ref={el => this["itemModal" + index] = el}
                            page={prop.page}
                            headers={prop.page?.headers}
                            initData={prop.data}
                            variables={this.props.variables}
                            itemAdded={this.itemAdded}
                            itemEdited={this.itemEdited}
                            openRefModal={this.openRefModal}
                            functionsHandler={this.functionsHandler}

                            showDates={true}
                            modalIndex={index}
                        />

                    )

                })}


                <RemoveModal
                    isLoading={this.state.isLoadingRemove}
                    removeFunction={this.fetchRemove}
                    ref={el => this.removeModal = el}
                />

            </div >
        )
    }
}




const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TableWidget);
